import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

export const StyledStarIcon = styled(SWReactIcons)<{ color: string }>`
    svg > polygon {
        fill: ${({ color }: { color: string }) => color};
    }
`;
